import { TextStyle } from '@tiptap/extension-text-style'

export const CustomTextStyle = TextStyle.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      class: {
        default: null,
        parseHTML: element => element.getAttribute('class'),
        renderHTML: attributes => {
          return {
            class: attributes.class,
          }
        },
      },
      'data-type': {
        default: null,
        parseHTML: element => element.getAttribute('data-type'),
        renderHTML: attributes => {
          return attributes['data-type']
            ? { 'data-type': attributes['data-type'] }
            : {}
        },
      },
      'data-label': {
        default: null,
        parseHTML: element => element.getAttribute('data-label'),
        renderHTML: attributes => {
          return attributes['data-label']
            ? { 'data-label': attributes['data-label'] }
            : {}
        },
      },
      'data-mention-type': {
        default: null,
        parseHTML: element => element.getAttribute('data-mention-type'),
        renderHTML: attributes => {
          return attributes['data-mention-type']
            ? { 'data-mention-type': attributes['data-mention-type'] }
            : {}
        },
      },
    }
  },
})
